import { createRoute } from '@tanstack/react-router';
import { appRoute } from './parent-routes';

const onlineFormsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: 'online-forms',
  component: () => null,
  staticData: {
    handle: { title: 'Online Forms' },
  },
});

export default onlineFormsRoute;
